import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
	// const config = useRuntimeConfig()
	Sentry.init({
		app: nuxtApp.vueApp,
		dsn: 'https://8568cbe11908655efd9b0eac9e1cbc68@o4511541023604736.ingest.de.sentry.io/4512287930318928',
		// environment: config.public.environment,
	})
})
